EnlighterJS.init('pre', '', {
    linehover: true,
    theme: 'atomic',
    indent: 4,
    linenumbers: false,
    textOverflow: 'scroll'
});